// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","title_text":"Header_title_text__Pxp9i","checkbox":"Header_checkbox__TFCMG","label":"Header_label__le1ef","theme_button":"Header_theme_button__qgWBf"};